import React from 'react'

const Data = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#63e240"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M49.782 40.095c0 1.355-1.123 2.453-2.507 2.453H12.178c-1.384 0-2.507-1.098-2.507-2.453v-.818h40.11zM36.087 52.363H23.366l2.785-8.179h7.151zM47.275 11.47h-.836v1.636h.836c1.384 0 2.507 1.098 2.507 2.453v22.082H9.672V15.56c0-1.355 1.122-2.453 2.506-2.453h.836V11.47h-.836c-2.306.003-4.175 1.832-4.178 4.09v24.535c.003 2.257 1.872 4.086 4.178 4.09H24.39l-2.785 8.178h-2.74v1.635H40.59v-1.635h-2.741l-2.785-8.179h12.21c2.307-.003 4.176-1.832 4.179-4.09V15.56c-.003-2.257-1.872-4.086-4.178-4.089z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M43.44 5H18.785c-1.361 0-2.465 1.078-2.465 2.409v28.1h1.644V7.41c0-.444.368-.803.821-.803H43.44c.453 0 .821.36.821.803v28.1h1.644V7.41C45.905 6.079 44.8 5 43.44 5z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M38.096 27.358a2.459 2.459 0 0 1-2.465-2.452 2.459 2.459 0 0 1 2.465-2.452 2.459 2.459 0 0 1 2.465 2.452 2.459 2.459 0 0 1-2.465 2.452zM24.95 33.874a2.456 2.456 0 0 1-2.465-2.447 2.456 2.456 0 0 1 2.465-2.447 2.456 2.456 0 0 1 2.465 2.447 2.456 2.456 0 0 1-2.465 2.447zm-.822-13.052a2.456 2.456 0 0 1-2.465-2.447 2.456 2.456 0 0 1 2.465-2.447 2.456 2.456 0 0 1 2.465 2.447 2.456 2.456 0 0 1-2.465 2.447zm13.968-11.42a2.459 2.459 0 0 1 2.465 2.452 2.459 2.459 0 0 1-2.465 2.452 2.459 2.459 0 0 1-2.465-2.452 2.459 2.459 0 0 1 2.465-2.452zm4.03 14.687a4.101 4.101 0 0 0-4.03-3.267H27.393a3.975 3.975 0 0 0 0-4.894h10.703c2.267-.003 4.105-1.828 4.108-4.08 0-2.252-1.84-4.078-4.108-4.078-2.27 0-4.108 1.826-4.108 4.079.003.885.299 1.745.843 2.447H24.128c-2.269 0-4.108 1.826-4.108 4.079 0 2.253 1.84 4.079 4.108 4.079h10.703a3.975 3.975 0 0 0 0 4.894H24.95c-2.27 0-4.108 1.826-4.108 4.08 0 2.252 1.839 4.078 4.108 4.078 2.269 0 4.108-1.826 4.108-4.079a4.018 4.018 0 0 0-.843-2.447h10.702v-.082c2.224-.448 3.66-2.601 3.209-4.809z"
            />
          </g>
          <g>
            <path fill="#fff" d="M35.74 10.55h1.849v1.85H35.74z" />
          </g>
          <g>
            <path fill="#fff" d="M22.79 18.87h1.85v1.85h-1.85z" />
          </g>
          <g>
            <path fill="#fff" d="M35.74 24.42h1.849v1.849H35.74z" />
          </g>
          <g>
            <path fill="#fff" d="M23.72 30.89h1.85v1.85h-1.85z" />
          </g>
          <g>
            <path fill="#fff" d="M19.09 7.77h1.85v1.85h-1.85z" />
          </g>
          <g>
            <path fill="#fff" d="M21.87 7.77h1.85v1.85h-1.85z" />
          </g>
          <g>
            <path fill="#fff" d="M24.64 7.77h1.85v1.85h-1.85z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Data
